<template>
    <div class="breadcrumbs" :class="rootClasses">
        <!-- <pre v-text="tree"></pre> -->

        <div class="breadcrumbs--gradient"></div>

        <ol class="u-reset breadcrumbs--items" itemscope itemtype="http://schema.org/BreadcrumbList">
            <li class="breadcrumbs--item" v-for="(item, itemIdx) in tree" :class="breadcrumbItemClasses(itemIdx)"
                    itemscope itemprop="itemListElement" itemtype="http://schema.org/ListItem">
                <span class="breadcrumbs--link-wrap">
                    <router-link :to="item.path" class="u-reset breadcrumbs--link"
                            itemscope itemtype="http://schema.org/Thing" itemprop="item">
                        <span class="breadcrumbs--link-inner"
                                itemprop="name"
                                v-html="item.title">
                        </span>
                    </router-link>
                    <meta itemprop="position" :content="itemIdx + 1"/>
                    <cmp-icon v-if="!isLast(itemIdx)"
                            class="breadcrumbs--chevron" symbol="chevron_right" size="x-small">
                    </cmp-icon>
                </span>
            </li>
        </ol>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('breadcrumbs'),
        ],
        props: {
            tree: Array,
        },
        computed: {
            ...mapGetters(['scroll']),
            rootClasses() {
                return [
                    this.bemAdd(this.scroll.scrollbarWidth <= 0 ? 'mobile-scroll' : ''),
                ];
            },
        },
        methods: {
            isLast(idx) {
                return idx === (this.tree.length - 1);
            },
            breadcrumbItemClasses(itemIdx) {
                return [
                    this.bemAdd(this.isLast(itemIdx) ? 'is-last' : '', 'item'),
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?7fefe229